import Swiper from 'swiper';

export default function (initialId) {

    console.log(initialId);

    let galleryThumbs = new Swiper('.modal-gallery .thumbs-gallery', {
        spaceBetween: 20,
        speed: 600,
        slidesPerView: 'auto',
        direction: 'horizontal',
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        slideToClickedSlide: true,
        initialSlide: initialId,
        breakpoints: {
            765: {
                slidesPerView: 'auto',
                spaceBetween: 20,
                direction: 'vertical',
                pagination: false
            }
        }
    });

    let galleryTop = new Swiper('.modal-gallery .detail-gallery', {
        effect: 'fade',
        speed: 600,
        fadeEffect: { crossFade: true },
        loop: false,
        initialSlide: initialId,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        pagination: {
            el: '.modal-gallery .swiper-pagination',
            clickable: true
        },
        breakpoints: {
            765: {
                pagination: false
            }
        },
        thumbs: {
            swiper: galleryThumbs
        }
    });


    let inlineVideo = document.getElementsByClassName('inline-video');

    Array.from(inlineVideo).forEach(button => button.addEventListener('click', function(e){
        this.classList.add('is-active');
    }));


}
